import { render, staticRenderFns } from "./rural.vue?vue&type=template&id=aee19932&scoped=true&"
import script from "./rural.vue?vue&type=script&lang=js&"
export * from "./rural.vue?vue&type=script&lang=js&"
import style0 from "./rural.vue?vue&type=style&index=0&id=aee19932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee19932",
  null
  
)

export default component.exports